import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NavbarComp from '../components/NavbarComp';
import FooterComp from '../components/FooterComp';
import { Container, Form, Button } from 'react-bootstrap'
import { getPofile, updateReminders, storeProfile } from '../hooks/auth'
import Time from '../components/Time'

const mapStateToProps = (state) => {
  return {
    auth: state.auth
  }
}

const getButtonDisable = (state) => {
  var deactive = state.update

  if((!state.reminder_by_email && !state.reminder_by_phone)) {
    deactive = true
  }
  if (!deactive && (state.reminder_by_email || state.reminder_by_phone)) {
    if (!state.alert_monday && !state.alert_tuesday && !state.alert_wednesday && !state.alert_thursday && !state.alert_friday && !state.alert_saturday && !state.alert_sunday) {
      deactive = true
    }
  }

  return deactive
}

const mapDispatchToProps = dispatch => ({
  getPofile: () => dispatch(getPofile()),
  storeProfile: () => dispatch(storeProfile()),
  updateReminders: (data) => dispatch(updateReminders(data))
});

class Reminders extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      reminder_by_phone: false,
      reminder_by_email: false,
      alert_monday: false,
      alert_tuesday: false,
      alert_wednesday: false,
      alert_thursday: false,
      alert_friday: false,
      alert_saturday: false,
      alert_sunday: false,
      alert_time: null,
      update: true
    };
    this.props.getPofile()
  }

  componentDidUpdate = () => {
    if (this.props.auth.profile != null) {
      var profile = this.props.auth.profile
      this.props.storeProfile()
      this.setState({
        reminder_by_phone: profile.reminder_by_phone,
        reminder_by_email: profile.reminder_by_email,
        alert_monday: profile.alert_monday,
        alert_tuesday: profile.alert_tuesday,
        alert_wednesday: profile.alert_wednesday,
        alert_thursday: profile.alert_thursday,
        alert_friday: profile.alert_friday,
        alert_saturday: profile.alert_saturday,
        alert_sunday: profile.alert_sunday,
        alert_time: profile.alert_time != null ? profile.alert_time : "12:00",
        update: true
      })
    }
  }

  timeChange = (time) => {
    this.setState({ "alert_time": time, update: false })
  }

  handleChecked = (event) => {
    this.setState({ [event.target.name]: event.target.checked, update: false })
  }

  updateReminders = () => {
    // disabled={getButtonDisable(this.state)} 
    this.props.updateReminders({
      reminder_by_phone: this.state.reminder_by_phone ? 1 : 0,
      reminder_by_email: this.state.reminder_by_email ? 1 : 0,
      alert_monday: this.state.alert_monday ? 1 : 0,
      alert_tuesday: this.state.alert_tuesday ? 1 : 0,
      alert_wednesday: this.state.alert_wednesday ? 1 : 0,
      alert_thursday: this.state.alert_thursday ? 1 : 0,
      alert_friday: this.state.alert_friday ? 1 : 0,
      alert_saturday: this.state.alert_saturday ? 1 : 0,
      alert_sunday: this.state.alert_sunday ? 1 : 0,
      alert_time: this.state.alert_time
    })
  }

  render() {
    return <Fragment>
      <NavbarComp access_token={true}/>
      <div className="page-sections">
        <div className="reminders-wrap">
          <Container>
            <div className="reminders-contents">
              <h2 className="main-title-style">REMINDERS</h2>
              <p>Here you can control your reminders. You can set a reminder to login to MyAlertness at the beginning of your shift.</p>
              <p>You can choose to have notifications by text (SMS) or email.</p>
              <p>You can set a reminder for your next shift or for your next series of shifts.</p>
              <div className='alertness-test-reminder'>
                <div className='phone-mail-reminder'>
                  <div key={`default-checkbox`} className="form-checkboxes">
                    <Form.Check onClick={this.handleChecked} checked={this.state.reminder_by_phone} name='reminder_by_phone' type="checkbox" id={`text-phone`} label={`Text by phone`} />
                    <Form.Check onClick={this.handleChecked} checked={this.state.reminder_by_email} name='reminder_by_email' type="checkbox" id={`email`} label={`Email`} />
                  </div>
                </div>
                <div className='alert-time-reminders'>
                  <Form.Group controlId="formGroupTime">
                    <Time time={24} label="Alert time" user_answers={this.state.alert_time} handleAnswerChange={this.timeChange} />
                  </Form.Group>
                </div>
                <div className='reminder-days'>
                  <div key={`default-checkbox`} className="form-checkboxes">
                    <Form.Check onClick={this.handleChecked} checked={this.state.alert_monday} name='alert_monday' type="checkbox" id={`monday`} label={`Monday`} />
                    <Form.Check onClick={this.handleChecked} checked={this.state.alert_tuesday} name='alert_tuesday' type="checkbox" id={`tuesday`} label={`Tuesday`} />
                    <Form.Check onClick={this.handleChecked} checked={this.state.alert_wednesday} name='alert_wednesday' type="checkbox" id={`wendesday`} label={`Wendesday`} />
                    <Form.Check onClick={this.handleChecked} checked={this.state.alert_thursday} name='alert_thursday' type="checkbox" id={`thursday`} label={`Thursday`} />
                    <Form.Check onClick={this.handleChecked} checked={this.state.alert_friday} name='alert_friday' type="checkbox" id={`friday`} label={`Friday`} />
                    <Form.Check onClick={this.handleChecked} checked={this.state.alert_saturday} name='alert_saturday' type="checkbox" id={`saturday`} label={`Saturday`} />
                    <Form.Check onClick={this.handleChecked} checked={this.state.alert_sunday} name='alert_sunday' type="checkbox" id={`sunday`} label={`Sunday`} />
                  </div>
                </div>
                <Button onClick={this.updateReminders} type="submit">SUBMIT</Button>
              </div>
            </div>
          </Container>
        </div>
      </div>
      <FooterComp />
    </Fragment>
  }
}

Reminders.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Reminders);
